import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import { TypedResourceRequest } from '../../Shared/Interfaces/api-request.interface';
import {
  FailedJobListResponse,
  FailedJobResponse,
  FailedJobRetryResponse,
  OpsHealthEnvelope,
  OpsHealthResponse,
} from '../../../Interfaces/api/backoffice/ops.interface';

@Injectable({
  providedIn: 'root',
})
export class OpsService {
  private readonly _apiService = inject(ApiService);

  healthRequest(): TypedResourceRequest<LaravelDefaultResponse<OpsHealthEnvelope>> {
    return this._apiService.get<LaravelDefaultResponse<OpsHealthEnvelope>>(
      endpoints.backoffice.opsHealth,
      { skipLoading: true, skipError: true },
    );
  }

  failedJobsRequest(): TypedResourceRequest<LaravelDefaultResponse<FailedJobListResponse>> {
    return this._apiService.get<LaravelDefaultResponse<FailedJobListResponse>>(
      endpoints.backoffice.opsFailedJobs,
      { skipLoading: true, skipError: true },
    );
  }

  retry(uuid: string): Observable<FailedJobRetryResponse> {
    const request = this._apiService.post<LaravelDefaultResponse<FailedJobRetryResponse>>(
      endpoints.backoffice.opsFailedJobsRetry,
      { body: { uuid }, skipError: true },
    );

    return this._apiService
      .run<LaravelDefaultResponse<FailedJobRetryResponse>>(request)
      .pipe(map((response) => response.data));
  }

  retryAll(): Observable<FailedJobRetryResponse> {
    const request = this._apiService.post<LaravelDefaultResponse<FailedJobRetryResponse>>(
      endpoints.backoffice.opsFailedJobsRetryAll,
      { skipError: true },
    );

    return this._apiService
      .run<LaravelDefaultResponse<FailedJobRetryResponse>>(request)
      .pipe(map((response) => response.data));
  }

  toHealth(
    response: LaravelDefaultResponse<OpsHealthEnvelope> | undefined,
  ): OpsHealthResponse | null {
    return response?.data?.health ?? null;
  }

  toFailedJobs(
    response: LaravelDefaultResponse<FailedJobListResponse> | undefined,
  ): FailedJobResponse[] {
    return response?.data?.failed_jobs ?? [];
  }

  toQueueName(response: LaravelDefaultResponse<FailedJobListResponse> | undefined): string {
    return response?.data?.queue ?? '';
  }
}
